<template>
  <div class="container">
    <div class="fixed">
      <b-tabs  @activate-tab="onTabChange"
               v-model="tabIndex"
               v-if="!$store.getters.getCopyNotification && !$store.getters.getTodayNotifyList && !$store.getters.getSiteForNotifyList"
               class="tab_bar container" fill>
        <b-tab :title="$t('more.send_noti')"   :title-link-class="['tab_text tab']"></b-tab>
        <b-tab  :title="$t('more.noti_modify')" :title-link-class="['tab_text tab']"></b-tab>
        <b-tab ref="auto" :title="$t('more.auto_noti')" :title-link-class="['tab_text tab']" ></b-tab>
      </b-tabs>
    </div>
    <div class="popup_header1 fixed" v-if="$store.getters.getCopyNotification">
      <span style="margin: auto">{{$t('more.copy_previous_notifications')}}</span>
      <h1 style="margin: 0; color: gray" @click="()=>{
        this.showCreate = true;
        this.$store.commit('setCopyNotification', false);
        this.tabIndex = this.toReturn;
        this.getList();
      }">
        <b-icon icon="x"></b-icon>
      </h1>
    </div>
    <div class="popup_header1 fixed" v-if="$store.getters.getTodayNotifyList " style="position: fixed; top:0;width: 100%;background: white">
      <span style="margin: auto">{{$t('more.notify_list')}}</span>
      <h1 style="margin: 0; color: gray"
          @click="()=>{
        this.$store.commit('setTodayNotifyList', false);
        this.$router.push('home');
      }"
      ><b-icon icon="x"></b-icon></h1>
    </div>
    <div class="popup_header1 fixed" v-if="$store.getters.getSiteForNotifyList" style="position: fixed; top:0;width: 100%;background: white">
      <span style="margin: auto">{{$t('interest.site_notify')}}</span>
      <h1 style="margin: 0; color: gray"
          @click="()=>{
        this.$store.commit('setSiteForNotifyList', null);
        this.$router.back();
      }"
      ><b-icon icon="x"></b-icon></h1>
    </div>
    <div :class="tabIndex == 2? 'container-content':'container-content-with-search'">
      <NotifyItem
        v-for="(item, i) in dataList"
        :key="i"
        :item="item"
        @click="onNotifyClick(i, item.f_idx, item.f_auto)"
        @longClick="onNotifyLongClick(i)"
        @deleteAuto="onDeleteAuto"
        style="margin-left: 1em; margin-right: 1em;"
        :is-auto="item.f_auto == 'Y'"
        :auto-index="i + 1"
      />
      <div class="align-horizontal center no_item" v-if="$store.getters.getSiteForNotifyList && dataList.length == 0">{{$t('more.no_notify')}}</div>
      <NotifyItem
        v-if="tabIndex + 1 == $c.NOTIFY_TAB.AUTO"
        :auto-index="dataList.length + 1"
        @click="(_data) => {
          $store.commit('setAutoNotification', true);
          $store.commit('setAutoNotificationInfo', _data);
          $store.commit('setAutoNotificationTitle', ut.format($t('notify.auto_noti_title'), dataList.length + 1))
          u.setState(self,{
            showCreate: true,
            isAuto: 'Y',
            notifySelected:null,
          });
        }"
        :is-auto-create="true"
        style="margin-left: 1em; margin-right: 1em;"
        ref="createItem"
      />
    </div>
    <Navbar :bar-visible="!$store.getters.getForceHideMainBottomBar">
      <SearchForm
        v-if="tabIndex +1 == $c.NOTIFY_TAB.MODIFY || $store.getters.getSiteForNotifyList || $store.getters.getTodayNotifyList"
        :searchValue.sync="keyword"
        :searchType.sync="searchType"
        :count="pageCnt"
        :hide-read-all="tabIndex + 1 == $c.NOTIFY_TAB.MODIFY"
        @change_page="change_page"
        @search="type_search"
        @delete="onDelete"
        @check="onCheckAll"
        @readAll="onReadAll"
        :is-all-read="this.dataList.some(it => {return it.f_read == 'N'})"
        :variant="$store.getters.getTodayNotifyList|| $store.getters.getCopyNotification ? 'today' : 'default'"
      ></SearchForm>
    </Navbar>
    <NotifyWritePopup
      v-if="showCreate"
      :is-auto="isAuto"
      :visible.sync="showCreate"
      :info="notifySelected"
      @move="(val) =>{
        self.tabIndex = val-1;
        // self.getList();
      }"
      @return="(val) =>{
        self.toReturn = val-1;
        // self.getList();
      }"
      @save="completeWriteNotify()" />
    <NotifyDetailPopup
      v-if="showDetail"
      :visible.sync="showDetail"
      :item="notifySelected" />
  </div>
</template>

<script>
import Utils from "../../../../config/utils";
import Navbar from "../../../controls/navbar";
import SearchForm from "../admin/controls/search_form";
import NotifyWritePopup from "../../../controls/popup/NotifyWritePopup";
import NotifyItem from "../../../controls/NotifyItem";
import NotifyDetailPopup from "../../../controls/popup/NotifyDetailPopup";

const u = require('util');

const SEARCH_COLUMN = [
  'f_title',
  'f_content',
  'f_title_content',
  'f_site_name',
  'f_contact',
];

export default {
  name: "Notify",
  components: {
    SearchForm,
    Navbar,
    NotifyWritePopup,
    NotifyItem,
    NotifyDetailPopup
  },
  data() {
    return {
      self:this,
      ut: u,
      u:Utils,
      tabIndex:1,
      dataList:[],
      pageCnt:1,
      totalCnt:1,
      limit:0,
      searchType:null,
      keyword:null,
      currentPage:1,
      notifySelected:null,
      showDetail:false,
      showCreate:false,
      isAuto:false,//자동알림tab에서 알림보내기 누를때 처리를 위한 기발
      toReturn: '',//이전알림복사에서 X단추 누르는 경우 돌아오는 위치
      pageTitle:'',
    }
  },
  inject:["eventBus"],
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setNotifyTabIndex', 1);
    this.$store.commit('setForceHideMainBottomBar', false);
    this.$store.commit('setCopyNotification', false);
    this.$store.commit('setAutoNotificationInfo', {title: null});
    this.$store.commit('setAutoNotification', false);
    this.$store.commit('setTodayNotifyList', false);
    next();
  },
  methods:{
    completeWriteNotify() {
      this.getList();
      if (this.tabIndex + 1 == this.$c.NOTIFY_TAB.AUTO) {
        this.$refs.createItem.init();
      }
    },
    onReadAll() {
      Utils.requestPost(
        this.$c.API.Notify.setRead,
        { notify_idx: 0 },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.getList();
        } else {
          Utils.toast(result.msg);
        }
      });
    },
    onCreate() {
      this.notifySelected = null;
      this.showCreate = true;
    },

    onCheckAll(state){
      this.dataList = this.dataList.map(it => {
        it.f_select = state;
        return it;
      });
    },

    onNotifyClick(index, item_idx, isAuto) {
      this.isAuto = this.isAuto == "Y" ? "Y" : isAuto;
      // debugger;
      if (!this.$store.getters.getCopyNotification && isAuto == 'N')
        this.$store.commit('setModifyNotification', item_idx)
      if (this.dataList.some(it => {
        return it.f_select;
      })) {
        // there is selected cell by long click
          this.dataList = this.dataList.map((it, idx) => {
            if (index == idx) {
              it.f_select = !it.f_select;
            }
            return it;
          });
        return;
      }
      if (this.tabIndex +1 == this.$c.NOTIFY_TAB.AUTO) {
        if(!this.$store.getters.getCopyNotification)
          this.$store.commit('setAutoNotificationTitle', u.format(this.$t('notify.auto_noti_title'), index+1))
        this.$store.commit('setAutoNotification', true);
      }
      // else
      //   this.$store.commit('setAutoNotificationTitle', null);
      if (!this.$store.getters.getTodayNotifyList && !this.$store.getters.getSiteForNotifyList) {
        if (this.tabIndex +1 == this.$c.NOTIFY_TAB.MODIFY || this.tabIndex +1 == this.$c.NOTIFY_TAB.AUTO) {
          this.notifySelected = this.dataList[index];
          if (this.$store.getters.getAutoNotification){
            if (this.$store.getters.getCopyNotification)
              this.tabIndex = this.toReturn;
            else
              this.tabIndex = 2;

            this.$store.commit('setAutoNotification', false);
            // this.$store.commit('setCopyNotification', false);
          }
          this.showCreate = true;
        }
      } else {
        if (this.dataList[index].f_read == 'N') {
          Utils.requestPost(
            this.$c.API.Notify.setRead,
            {
              notify_idx: this.dataList[index].f_idx,
            },
          ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.setState(this,{
                showDetail: true,
                notifySelected: this.dataList[index],
                dataList: this.dataList.map((it, idx) => {
                  if (index == idx) {
                    it.f_read = 'Y';
                  }
                  return it;
                })
              });
            } else {
              Utils.toast(this, result.msg);
            }
          });
        } else {
          Utils.setState(this, {
            notifySelected: this.dataList[index],
            showDetail: true,
          });
        }
      }
    },

    onNotifyLongClick(index){
      if (this.tabIndex != this.$c.NOTIFY_TAB.AUTO -1)
      this.dataList = this.dataList.map((it, idx) => {
        if (index == idx) {
          it.f_select = true;
        }
        return it;
      });
    },

    onDeleteAuto(index){
      this.dataList = this.dataList.filter((it, idx) => {
        if (index != idx) {
          return it;
        }
      });
    },

    onDelete(){
      let self = this;
      let selectList = this.dataList.filter(it => {
        return it.f_select;
      }).map(it => {
          return it.f_idx;
        },
      );
      if (selectList.length < 1) {
        return;
      }
        Utils.showConfirm(
          this,
          this.$t("notify.delete_confirm")
        ).then(
          value =>{
            if (value){
              Utils.requestPost(
                this.$c.API.Notify.removeNotify,
                {
                  idx_list: JSON.stringify(selectList),
                },
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  Utils.toast(this, this.$t("common.delete_success"));
                  this.getList();
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        );
    },

    change_page(page){
      this.currentPage = page;
      this.getList();
    },

    type_search(){
      this.getList();
    },

    getList(){
      this.dataList = [];
      let url = this.$c.API.Notify.getMyNotifyList;
      if (this.$store.getters.getCopyNotification){
        if (this.tabIndex == 2)
          url = this.$c.API.Notify.getMyAutoNotify;
        else
          url = this.$c.API.Notify.getMyNotifyList;
      }
      else {
        if (this.$store.getters.getTodayNotifyList)
          url = this.$c.API.Notify.getNotifyList
        else if (this.tabIndex + 1 == this.$c.NOTIFY_TAB.AUTO) {
          url = this.$c.API.Notify.getMyAutoNotify;
        }
        else if(this.$store.getters.getSiteForNotifyList) {
          url = this.$c.API.Notify.getSiteNotifyList;
        }
      }
      Utils.requestGet( url,
        {
          site_idx: this.$store.getters.getSiteForNotifyList,
          page_num: this.currentPage,
          column: this.searchType,
          keyword: this.searchType == SEARCH_COLUMN[4] ? this.keyword.replaceAll('-', '') : this.keyword,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.totalCnt = result.data.total;
            this.pageCnt = result.data.page_count;
            this.limit = result.data.limit;
            this.pageNum += 1;
            this.dataList = result.data.list.map(it => {
              it.f_select = false;
              return it;
            });
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    getProfile() {
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(async result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          this.myinfo.loadInfo();
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onTabChange(newtab,prevtab,e){
      if (newtab == 0){
        this.isAuto = 'N';
        this.$store.commit('setIsAutoPage', false);
        e.preventDefault();
        this.eventBus.$emit('checkTicketAvailable', () => {
          this.$store.commit('setAutoNotificationTitle', null);
          this.tabIndex = prevtab;
          this.notifySelected = null;
          this.showCreate = true;
        })
      }
    },
  },
  watch: {
    tabIndex: function (newtab, oldtab) {
      // this.$store.commit('setModifyNotification', null);
      if(newtab == 1){
        this.getList();
        this.$store.commit('setIsAutoPage', false);
        this.$store.commit('setSiteForNotifyList', null);
      } else if (newtab == 2) {
        this.getList();
        this.getProfile();
        this.$store.commit('setIsAutoPage', true);
      } else if (newtab == 0){
        this.$store.commit('setIsAutoPage', false);
      }
    }
  },
  beforeMount() {
    this.tabIndex = this.$store.getters.getNotifyTabIndex -1;
  },

  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.MORE);
    this.getList();
  },
}
</script>

<style lang="scss">
@import '../../../../assets/css/_vars.scss';
.no_item {
  color: $text;
  font-size: $fs_20;
  font-family: $korean_gd_13_r;
  margin-top: 200px;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/notify/Notify.vue